module.exports = __webpack_public_path__ + "4fe49148c8eae0eb379612162fd31008.pdf";